export default {
	state: {
		loginShow: false,//是否显示登录
		isShowDetail:false,
		giftGetType:0,
		giftGameUrl:"",
		giftExplain:false,
		giftExplainText:"",
		giftCode:"",
		detailMsg:{},
		gameUrl:"",
		bigPhoto:""
	},
	mutations: {
		LoginShow(state, loginShow) {
			state.loginShow = loginShow
		},
		IsShowDetail(state, isShowDetail) {
			state.isShowDetail = isShowDetail
		},
		GiftGetType(state, giftGetType) {
			state.giftGetType = giftGetType
		},
		GiftGameUrl(state, giftGameUrl) {
			state.giftGameUrl = giftGameUrl
		},
		GiftExplain(state, giftExplain) {
			state.giftExplain = giftExplain
		},
		GiftExplainText(state, giftExplainText) {
			state.giftExplainText = giftExplainText
		},
		GiftCode(state, giftCode) {
			state.giftCode = giftCode
		},
		GetDetailMsg(state, detailMsg) {
			state.detailMsg = detailMsg
		},
		GetGameUrl(state, gameUrl) {
			state.gameUrl = gameUrl
		},
		BigPhoto(state, bigPhoto) {
			state.bigPhoto = bigPhoto
		},
	},

	actions: {
		LoginShowFun(context, n) {
			context.commit('LoginShow', n)
		},
		IsShowDetailFun(context, n) {
			context.commit('IsShowDetail', n)
		},
		GiftGetTypeFun(context, n) {
			context.commit('GiftGetType', n)
		},
		GiftGameUrlFun(context, n) {
			context.commit('GiftGameUrl', n)
		},
		GiftExplainFun(context, n) {
			context.commit('GiftExplain', n)
		},
		GiftExplainTextFun(context, n) {
			context.commit('GiftExplainText', n)
		},
		GiftCodeFun(context, n) {
			context.commit('GiftCode', n)
		},
		GetDetailMsgFun(context, n) {
			n = JSON.parse(n)?JSON.parse(n):n;
			context.commit('GetDetailMsg', n)
		},
		GetGameUrlFun(context, n) {
			context.commit('GetGameUrl', n)
		},
		BigPhotoFun(context, n) {
			context.commit('BigPhoto', n)
		},
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/common.js